module.exports = __webpack_public_path__ + "static/socialism-238a1e24ada5dd77d35c5f44507864e9.jpg";